// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabs":"app-components-kit-tabs-tabs--tabs","item":"app-components-kit-tabs-tabs--item","itemActive":"app-components-kit-tabs-tabs--itemActive"};